import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import { GetSimConfigResponse } from 'api/types/simConfig'

class SimConfig {
  // Save simulation configuration
  async saveSimConfig(
    id: number | null,
    product: string,
    content: string,
    version: string | null,
  ): Promise<string | (AxiosError | Error)> {
    const url = `${APIRoutes.simConfig.saveSimConfig}`
    const body = new FormData()

    if (id !== null) body.append('Id', String(id))
    body.append('Product', product)
    body.append('Content', content)
    if (version !== null) body.append('Version', version)

    return ApiProvider.postRequest(url, body, true) as Promise<
      string | (AxiosError | Error)
    >
  }

  // get simulation rating
  async getSimConfig(
    product: string,
  ): Promise<GetSimConfigResponse | (AxiosError | Error)> {
    const url = `${APIRoutes.simConfig.getSimConfig}?product=${product}`
    return ApiProvider.getRequest(url) as Promise<
      GetSimConfigResponse | (AxiosError | Error)
    >
  }
}

export const simConfigService = new SimConfig()
